module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00037-fs8.58ee52b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00037-fs8.png
// module id = 190
// module chunks = 0